import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const metaFn = /* @__PURE__ */ createRecipe('meta', {}, [])

const metaVariantMap = {}

const metaVariantKeys = Object.keys(metaVariantMap)

export const meta = /* @__PURE__ */ Object.assign(memo(metaFn.recipeFn), {
  __recipe__: true,
  __name__: 'meta',
  __getCompoundVariantCss__: metaFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: metaVariantKeys,
  variantMap: metaVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, metaVariantKeys)
  },
  getVariantProps: metaFn.getVariantProps,
})